import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import chinese from './locales/chinese/translation.json';
import english from './locales/english/translation.json';
import japanese from './locales/japanese/translation.json';

export const SUPPORTED_LANGUAGES = ['english', 'chinese', 'japanese'];

const getInitialLanguage = () => {
    try {
        const stored = window.localStorage.getItem('language');
        return stored && SUPPORTED_LANGUAGES.includes(stored) ? stored : 'english';
    } catch {
        return 'english';
    }
};

i18n.use(initReactI18next).init({
    resources: {
        english: { translation: english },
        chinese: { translation: chinese },
        japanese: { translation: japanese },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'english',
    // Language keys are the backend's legacy identifiers, not BCP-47 codes;
    // stop i18next from deriving regional variants from them.
    load: 'currentOnly',
    // Resources are bundled, so init synchronously: i18n.t is usable at import time.
    initImmediate: false,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
} as any);

i18n.on('languageChanged', (lng) => {
    try {
        window.localStorage.setItem('language', lng);
    } catch {
        // Storage unavailable (tests, privacy mode); language just won't persist.
    }
});

export default i18n;
